define('components/popin/Popin', [
    'components/popin/models/PopinModel',
    'components/popin/views/PopinView'
], function(PopinModel, PopinView) {

    var _model = {};
    var _view = {};

    return {
        open: function(popinId, options) {
            if (_.isUndefined(_model[popinId])) {
                _model[popinId] = new PopinModel(options);
                _view[popinId] = new PopinView({ "model": _model[popinId] });
            } else {
                if (_model[popinId].get('open')) {
                    if (_model[popinId].get('animation') ) {
                        _model[popinId].once('change:open', function( model, open ) {
                            if( !open ) {
                                setTimeout( function() {
                                    _model[popinId].clear({silent: true}).set(_model[popinId]['defaults'], {silent: true}); // jshint ignore:line
                                    _model[popinId].set(options);
                                }, 40);
                            }
                        });
                    }

                    _view[popinId].close();
                }

                if( !_model[popinId].get('open') ) {
                    _model[popinId].clear({silent: true}).set(_model[popinId]['defaults'], {silent: true}); // jshint ignore:line
                    _model[popinId].set(options);
                }
            }
        },

        close: function(popinId, isManual) {
            if (!_.isUndefined(_model[popinId]) && _model[popinId].get('open')) {
                _view[popinId].close(isManual);
            }
        },

        updateView: function( popinId, view ) {
            if (!_.isUndefined(_model[popinId])) {
                _model[popinId].set('view', view);
            }
        },

        onEnter: function( popinId ) {
            if (!_.isUndefined(_model[popinId]) && _model[popinId].get('open')) {
                _view[popinId].onEnter();
            }
        },

        onLeave: function( popinId ) {
            if (!_.isUndefined(_model[popinId]) && _model[popinId].get('open')) {
                _view[popinId].onLeave();
            }
        },

        isOpen: function( popinId ) {
            if (!_.isUndefined(_model[popinId])) {
                return _model[popinId].get('open');
            } else {
                console.warn('[Popin -> isOpen] Popin ' + popinId + " does not exist");
                return false;
            }
        },

        onScroll: function( popinId, e ) {
            _view[popinId].onScroll( e );
        }
    };
});
